import { useTranslation } from 'react-i18next'

import { Checkbox, CHECKBOX_SIZE } from '../../../../../../../Checkbox'
import { getListingPortalLabel } from '../../../../../../../RentalPortalListing'
import { QA_NAME_LISTING_FORM_PORTAL_CHECKBOX } from '../../PortalsField.constants'
import {
  getIsListingPortalLocked,
  getListingPortalRowTooltip,
  getToggledListingPortals,
} from '../../PortalsField.utils'

import * as styles from './PortalsFieldCheckbox.module.css'

function PortalsFieldCheckbox({
  disabled,
  disabledReason,
  isChecked,
  portal,
  value,
  onChange,
}) {
  const { t } = useTranslation()

  function handleChange(isNextChecked) {
    onChange(
      getToggledListingPortals({
        isChecked: isNextChecked,
        portal: portal.portal,
        portals: value,
      })
    )
  }

  const tooltip = getListingPortalRowTooltip({ disabledReason, portal, t })

  return (
    <Checkbox
      checked={isChecked}
      className={styles.PortalsFieldCheckbox}
      disabled={getIsListingPortalLocked({ disabled, isChecked, portal })}
      label={getListingPortalLabel(portal.portal)}
      qaName={QA_NAME_LISTING_FORM_PORTAL_CHECKBOX}
      showTooltip={Boolean(tooltip)}
      size={CHECKBOX_SIZE.small}
      tooltip={tooltip}
      onChange={handleChange}
    />
  )
}

export default PortalsFieldCheckbox
